<div style="text-align:center; align-self: start"><img src="../../../assets/img/ibex-logo-text-new-new.png"/></div>

<p>Register a new account</p>

<mat-form-field>
  <input [(ngModel)]="email" matInput name="email" placeholder="Email address">
  <mat-hint *ngIf="!validateEmail()">email not valid</mat-hint>
</mat-form-field>

<password-confirm (validation)="onPasswordValidatiton($event)"></password-confirm>

<p>
  <button (click)="register()" [disabled]="!password || !validateEmail() "
          color="primary"
          mat-raised-button>Register
  </button>
</p>

<button (click)="navigateToLogin()" mat-button>Login</button>
